import { LayoutDashboard, Building2, HelpCircle, TrendingUp, Lock } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

interface MobileBottomNavProps {
  journeyCompleted: boolean;
}

export function MobileBottomNav({ journeyCompleted }: MobileBottomNavProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    ...(!journeyCompleted
      ? [{ icon: TrendingUp, label: "Journey", path: "/journey", locked: false }]
      : []),
    { icon: LayoutDashboard, label: "Dashboard", path: "/dashboard", locked: false },
    { icon: Building2, label: "Governance", path: "/governance", locked: false },
    { icon: HelpCircle, label: "Support", path: "/support", locked: false },
  ];

  const isActive = (path: string) => location.pathname === path || location.pathname.startsWith(path + "/");

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/60 border-t z-50 safe-area-pb">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          const locked = item.locked;
          return (
            <button
              key={item.path}
              onClick={() => !locked && navigate(item.path)}
              disabled={locked}
              className={cn(
                "flex flex-col items-center justify-center gap-1 min-w-[44px] min-h-[44px] flex-1 transition-colors relative",
                active ? "text-gold" : "text-muted-foreground",
                locked && "opacity-50 cursor-not-allowed",
              )}
            >
              <div className="relative">
                <Icon className={cn("h-5 w-5", active && "scale-110")} />
                {locked && <Lock className="h-2.5 w-2.5 absolute -top-1 -right-1" />}
              </div>
              <span className="text-[10px] font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
